import { Component } from 'react'
import Select from 'react-select'
import { Link } from 'react-router-dom'
import { KeyValuePairs, Input } from 'components/ideal-core-ui'
import DatePicker from 'react-datepicker'
import { NumericFormat } from 'react-number-format'
import {
  fromConstantPropertyToSelectOptions,
  fromConstantPropertyToSelectValue
} from 'utils/serializers'
import { APP_CONSTANTS } from 'utils/constants'
import s from './Logistics.scss'
import { getCurrency, getDateFormat } from 'utils/authService'
import { timezoneDate, utcDate, utcCurrentDate } from 'utils/helpers'
import moment from 'moment-timezone'

class Logistics extends Component {
  render() {
    const {
      name,
      value,
      dueDate,
      followUpDate,
      status,
      assignee,
      assignees,
      contacts,
      signed,
      changeProperty,
      changeAssignee,
      changeStatus,
      createdAt,
      createdBy,
      updatedAt,
      updatedBy,
      approvedAt,
      approvedBy,
      sentForReviewAt,
      sentForReviewTo,
      dateSigned,
      updateState,
      quoteNumber
    } = this.props

    const prposalDueDate = dueDate || utcCurrentDate()

    return (
      <KeyValuePairs
        pairs={[
          {
            key: '*Name',
            value: (
              <Input
                type="text"
                text={name || ''}
                placeholder="Enter Proposal Name"
                onChangeCb={() => updateState(event.target.value, 'name')}
              />
            )
          },
          {
            key: '*Status',
            value: (
              <Select
                value={fromConstantPropertyToSelectValue(status, 'ProposalStatus')}
                onChange={value => changeStatus(value)}
                options={fromConstantPropertyToSelectOptions(
                  Object.keys(APP_CONSTANTS.ProposalStatus),
                  'ProposalStatus'
                )}
              />
            )
          },
          {
            key: 'Quote Number',
            value: (
              <Input
                type="text"
                text={(quoteNumber && String(quoteNumber)) || ''}
                className={s.nameInput}
                placeholder="Enter Quote Number"
                onChangeCb={() =>
                  updateState(event.target.value.replace(/[^a-zA-Z0-9_-]/g, ''), 'quoteNumber')
                }
              />
            )
          },
          {
            key: 'Assignee',
            value: (
              <Select
                value={assignee}
                onChange={value => changeAssignee(value)}
                options={assignees}
              />
            )
          },
          {
            key: `Value ${getCurrency().symbol}`,
            value: (
              <NumericFormat
                thousandSeparator
                decimalScale={2}
                value={value}
                prefix={getCurrency().symbol}
                onValueChange={formattedValue => updateState(formattedValue.value, 'value')}
                className={s.currencyInput}
                placeholder="Enter Value"
              />
            )
          },
          {
            key: 'Due Date',
            value: (
              <DatePicker
                selected={moment(
                  timezoneDate(prposalDueDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                startDate={moment(
                  timezoneDate(prposalDueDate, 'HH:mm:ss'),
                  `${getDateFormat()} HH:mm:ss`
                ).toDate()}
                onChange={value => {
                  const date = value && value !== null ? utcDate(value) : ''
                  changeProperty(date, 'dueDate')
                }}
                showTimeSelect
                timeFormat="h:mm aa"
                timeIntervals={15}
                dateFormat={`${getDateFormat()
                  .replace('YYYY', 'yyyy')
                  .replace('DD', 'dd')} h:mm aa`}
                timeCaption="time"
                placeholderText="Select proposal due date"
                className={s.dateInput}
              />
            )
          },
          followUpDate
            ? {
                key: 'Follow-up Date',
                value: (
                  <DatePicker
                    value={followUpDate ? timezoneDate(followUpDate) : ''}
                    onChange={value => {
                      const date = value ? utcDate(value) : ''
                      changeProperty(date, 'followUpDate')
                    }}
                    className={s.dateInput}
                  />
                )
              }
            : {},
          {
            key: 'Created By',
            value: <span>{createdBy}</span>
          },
          {
            key: 'Created At',
            value: <span>{timezoneDate(createdAt) || ''}</span>
          },
          {
            key: 'Updated By',
            value: <span>{updatedBy}</span>
          },
          {
            key: 'Updated At',
            value: <span>{timezoneDate(updatedAt) || ''}</span>
          },
          contacts.length
            ? {
                key: 'Sent To',
                value: (
                  <div>
                    {contacts.map((contact, index) => (
                      <div key={`${contact.id}-${index}`} className={s.contactHisotryRow}>
                        <Link to={`/contacts/${contact.id}`} className={s.link}>
                          {contact.firstName} {contact.lastName}
                        </Link>
                        {contact.proposalReceivedDate && (
                          <div>
                            Received date: {timezoneDate(contact.proposalReceivedDate, 'h:mm A')}
                          </div>
                        )}
                        <div>Sent date: {timezoneDate(contact.proposalSentDate, 'h:mm A')}</div>
                      </div>
                    ))}
                  </div>
                )
              }
            : {},
          sentForReviewTo?.length
            ? {
                key: 'Sent for Review to',
                value: (
                  <div className={s.reviwersContainer}>
                    {sentForReviewTo.map(user => (
                      <Link to={`/users/${user.id}`} className={s.link} key={`user-${user.id}`}>
                        {user.firstName} {user.lastName}
                      </Link>
                    ))}
                    at <span>{timezoneDate(sentForReviewAt, 'h:mm A')}</span>
                  </div>
                )
              }
            : {},
          approvedBy?.length
            ? {
                key: 'Approved by',
                value: (
                  <div className={s.reviwersContainer}>
                    {approvedBy.map(user => (
                      <Link to={`/users/${user.id}`} className={s.link} key={`user-${user.id}`}>
                        {user.firstName} {user.lastName}
                      </Link>
                    ))}
                    at <span>{timezoneDate(approvedAt, 'h:mm A')}</span>
                  </div>
                )
              }
            : {},
          {
            key: 'Signed by Client',
            value: (
              <Select
                value={fromConstantPropertyToSelectValue(signed, 'ProposalSigned')}
                onChange={value => changeProperty(value.value, 'signed')}
                options={fromConstantPropertyToSelectOptions(
                  Object.keys(APP_CONSTANTS.ProposalSigned),
                  'ProposalSigned'
                )}
              />
            )
          },
          dateSigned
            ? {
                key: 'Signed On',
                value: <span>{dateSigned}</span>
              }
            : {}
        ]}
      />
    )
  }
}

export default Logistics
